<p-dialog [(visible)]="ooCanvasMenuItem" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="w-100">
			<div class="d-flex">
				<fa-icon [icon]="['far', 'burger-soda']" class="me-4" size="2x"></fa-icon>
				<div class="display-8 ms-1 my-auto">
					<span *ngIf="ooCanvasMenuItem && ooCanvasMenuItem.ooMenuItem">
						{{ ooCanvasMenuItem.ooMenuItem.name }}
					</span>
					<span *ngIf="!ooCanvasMenuItem"> Add Item </span>
				</div>
				<div class="ms-5">
					<fa-icon
						[icon]="['far', 'link']"
						size="lg"
						(click)="
							app.copyMessage(
								'https://app.focuspos.com/' +
									venueSvc.subscriptionVenue.value.key +
									'?cmi=' +
									ooCanvasMenuItem.canvasKey +
									'_' +
									ooCanvasMenuItem.menuItemKey
							)
						"
					></fa-icon>
				</div>
			</div>
			<p-divider></p-divider>
		</div>
	</ng-template>
	<form #itemForm="ngForm">
		<div *ngIf="!ooCanvasMenuItem.includedItem">
			<div class="d-flex flex-column">
				<div *ngIf="sourceComponent === 'canvas' && newRecord" class="d-flex flex-column">
					<div>Select Menu Item</div>
					<p-dropdown
						required
						placeholder="Select a menu item..."
						[options]="venueSvc.ooMenuItems"
						optionLabel="name"
						optionValue="menuItemKey"
						name="ooMenuItemList"
						[virtualScroll]="venueSvc.ooMenuItems?.length > 50"
						virtualScrollItemSize="30"
						[filter]="true"
						filterBy="name"
						[(ngModel)]="ooCanvasMenuItem.menuItemKey"
						(onChange)="setOOMenuItem(ooCanvasMenuItem.menuItemKey)"
						styleClass="m-2"
						[style]="{ width: '100%' }"
						appendTo="body"
					>
					</p-dropdown>
				</div>

				<div *ngIf="sourceComponent === 'item' && newRecord" class="d-flex flex-column">
					<div>Select Canvas</div>
					<p-dropdown
						required
						placeholder="Select a canvas..."
						[options]="venueSvc.ooCanvases"
						optionLabel="name"
						optionValue="canvasKey"
						name="canvasList"
						[virtualScroll]="venueSvc.ooCanvases"
						virtualScrollItemSize="30"
						[filter]="true"
						filterBy="name"
						[(ngModel)]="ooCanvasMenuItem.canvasKey"
						(onChange)="setOOCanvasKey(ooCanvasMenuItem.canvasKey)"
						[style]="{ width: '100%' }"
						styleClass="m-2"
						appendTo="body"
					></p-dropdown>
				</div>

				<div *ngIf="duplicateOoCanvasMenuItemDetected" class="red m-2 text-center text-uppercase" style="color: red">
					<span *ngIf="sourceComponent === 'canvas'"> the selected menu item already exists on this canvas. </span>
					<span *ngIf="sourceComponent === 'item'"> the selected canvas already contains this item. </span>
				</div>

				<input
					pInputText
					[disabled]="duplicateOoCanvasMenuItemDetected"
					type="text"
					placeholder="Display Name on canvas"
					name="displayName"
					[(ngModel)]="ooCanvasMenuItem.displayName"
					class="w-100 m-2"
				/>
				<div class="p-grid">
					<div class="p-col-12 p-md-3">
						<div class="my-auto display-14" style="vertical-align: middle">Available online</div>
						<p-inputSwitch
							name="ooCanvasMenuItemOnline"
							[disabled]="duplicateOoCanvasMenuItemDetected"
							[(ngModel)]="ooCanvasMenuItem.online"
							(onChange)="changesToSave = true"
							styleClass="ms-2"
						></p-inputSwitch>
					</div>
					<div class="p-col-12 p-md-3">
						<div class="my-auto display-14">Taxable</div>
						<p-inputSwitch
							name="ooCanvasMenuItemTaxable"
							[disabled]="duplicateOoCanvasMenuItemDetected"
							[(ngModel)]="ooCanvasMenuItem.taxable"
							(onChange)="changesToSave = true"
							styleClass="ms-2"
						></p-inputSwitch>
					</div>
					<div class="p-col-12 p-md-3">
						<div class="my-auto display-14">Quick Add</div>
						<p-inputSwitch
							name="ooCanvasMenuItemQuickAdd"
							[disabled]="duplicateOoCanvasMenuItemDetected"
							[(ngModel)]="ooCanvasMenuItem.quickAdd"
							(onChange)="changesToSave = true"
							styleClass="ms-2"
						></p-inputSwitch>
					</div>
					<div class="p-col-12 p-md-3">
						<div class="my-auto display-14">Pre-selected</div>
						<p-inputSwitch
							name="ooCanvasMenuItemPreselected"
							[disabled]="duplicateOoCanvasMenuItemDetected"
							[(ngModel)]="ooCanvasMenuItem.preselected"
							(onChange)="changesToSave = true"
							styleClass="ms-2"
						></p-inputSwitch>
						<div class="display-18">Modifiers only - this item will be pre-selected as a modifier when used on a Modifier Canvas.</div>
					</div>
				</div>

				<div class="p-grid mt-4">
					<div class="p-col">
						<span class="p-float-label mt-4">
							<p-dropdown
								required
								*ngIf="ooCanvasMenuItem.ooMenuItem"
								#itemPriceValueSelect
								[options]="itemPriceOptions"
								optionLabel="label"
								optionValue="value"
								name="itemPriceValueSelect"
								[(ngModel)]="ooCanvasMenuItem.priceNumber"
								[style]="{ width: '100%' }"
								appendTo="body"
								[autoDisplayFirst]="false"
								[virtualScroll]="true"
								itemSize="30"
								filter="true"
								(filterBy)="app.keys(itemPriceOptions)"
							></p-dropdown>
							<label for="itemPriceValueSelect">Price</label>
						</span>
					</div>
				</div>
				<div class="p-grid mt-4">
					<div class="p-col">
						<span class="p-float-label mt-4">
							<textarea
								pInputTextarea
								#itemDescriptionInput
								name="itemDescriptionInput"
								[(ngModel)]="ooCanvasMenuItem.description"
								class="w-100 mt-1"
							></textarea>
							<label for="itemDescriptionInput">Description</label>
						</span>
					</div>
				</div>
				<div class="p-grid mt-4">
					<div class="p-col">
						<span class="p-float-label">
							<p-dropdown
								#canvasTimeRangePicker
								[options]="venueSvc.timeRanges"
								optionLabel="name"
								optionValue="key"
								name="timeRangeList"
								[autoDisplayFirst]="false"
								(onChange)="timeRangeSelect($event)"
								[style]="{ width: '100%' }"
								appendTo="body"
							>
							</p-dropdown>
							<label for="canvasTimeRangePicker" class="ms-2">Item Time Ranges</label>
						</span>
					</div>
				</div>
				<div class="p-grid" *ngIf="ooCanvasMenuItem.OOCanvasMenuItemTimeRange">
					<div class="p-col">
						<div *ngIf="ooCanvasMenuItem.OOCanvasMenuItemTimeRange" class="d-flex flex-row mt-2">
							<div *ngFor="let canvasItemTimeRange of ooCanvasMenuItem.OOCanvasMenuItemTimeRange">
								<p-tag
									value="{{ canvasItemTimeRange.name }}"
									severity="danger"
									icon="pi pi-times"
									styleClass="mx-2"
									(click)="timeRangeRemove(canvasItemTimeRange.timeRangeKey)"
								></p-tag>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div *ngIf="ooCanvasMenuItem.includedItem">
			<div class="d-flex flex-column">
				<div class="mt-5">
					<span class="p-float-label mt-2">
						<p-dropdown
							#menuItemSelected
							[options]="venueSvc.ooMenuItems"
							optionLabel="name"
							optionValue="menuItemKey"
							[virtualScroll]="venueSvc.ooMenuItems?.length > 50"
							virtualScrollItemSize="30"
							[filter]="true"
							filterBy="name"
							[(ngModel)]="ooCanvasMenuItem.menuItemKey"
							name="venueSvc.ooMenuItems"
							styleClass="w-100"
							(onChange)="setOOMenuItem(ooCanvasMenuItem.menuItemKey)"
							[autoDisplayFirst]="false"
							appendTo="body"
						></p-dropdown>
						<label for="menuItemSelected">Selected menu item</label>
					</span>
					<span class="p-float-label mt-4">
						<input pInputText #displayNameText name="displayNameText" type="text" [(ngModel)]="ooCanvasMenuItem.displayName" class="w-100" />
						<label for="displayNameText">Display Name</label>
					</span>

					<span class="p-float-label mt-4">
						<p-dropdown
							#itemPriceOptionsList
							[options]="itemPriceOptions"
							optionLabel="label"
							[autoDisplayFirst]="false"
							[disabled]="!ooCanvasMenuItem.menuItemKey"
							optionValue="value"
							name="itemPriceOptions"
							[(ngModel)]="ooCanvasMenuItem.priceNumberNo"
							[style]="{ width: '100%' }"
							appendTo="body"
							autoDisplayFirst="false"
						></p-dropdown>
						<label for="itemPriceOptionsList">No Price</label>
					</span>
					<span class="p-float-label mt-4">
						<p-dropdown
							#itemPriceOptionsList
							[options]="itemPriceOptions"
							optionLabel="label"
							[autoDisplayFirst]="false"
							[disabled]="!ooCanvasMenuItem.menuItemKey"
							optionValue="value"
							name="itemPriceOptions"
							[(ngModel)]="ooCanvasMenuItem.priceNumberLite"
							[style]="{ width: '100%' }"
							appendTo="body"
							autoDisplayFirst="false"
						></p-dropdown>
						<label for="itemPriceOptionsList">Lite Price</label>
					</span>
					<span class="p-float-label mt-4">
						<p-dropdown
							#itemPriceOptionsList
							[options]="itemPriceOptions"
							optionLabel="label"
							[autoDisplayFirst]="false"
							[disabled]="!ooCanvasMenuItem.menuItemKey"
							optionValue="value"
							name="itemPriceOptions"
							[(ngModel)]="ooCanvasMenuItem.priceNumberExtra"
							[style]="{ width: '100%' }"
							appendTo="body"
							autoDisplayFirst="false"
						></p-dropdown>
						<label for="itemPriceOptionsList">Extra Price</label>
					</span>
					<span class="p-float-label mt-4">
						<textarea pInputTextarea #cmiDescription name="cmiDescription" [(ngModel)]="ooCanvasMenuItem.description" class="w-100 mt-1"></textarea>
						<label for="cmiDescription">Description</label>
					</span>
				</div>
			</div>
		</div>
	</form>

	<p-footer>
		<app-record-control-footer
			(onCancelChange)="closeEmitter.emit(true)"
			(onSaveChange)="onSave(ooCanvasMenuItem)"
			[hideDelete]="true"
		></app-record-control-footer>
	</p-footer>
</p-dialog>
